import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {  baseURLGetPage } from "../config/api";
import Zebra from "./Zebra";
import Roller from "./Roller";
import DualRoller from "./DualRoller";
import DK from "./DK";
import DK2 from "./DK2";
import { useSelector } from "react-redux";
import axios from "axios";
import Grommet from "./Grommet";
import Grommet2 from "./Grommet2";
import Grommet3 from "./Grommet3";
import PleatedOne from "./PleatedOne";
import PleatedTwo from "./PleatedTwo";
import PleatedThree from "./PleatedThree";
import Roman from "./Roman";
import Roman2 from "./Roman2";



function CustomCurtain() {
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  let navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { catID } = useParams();
  const { modelID } = useParams();
  // console.log(`modelID`, modelID);
  const { specialID } = useParams();
  const { projectId } = useParams();
  const { editIndex } = useParams();
  const { websitePageItemId } = useParams();
  const [pageModel, setPageModel] = useState([]);

  const setPage = () => {
    let queryObj;
    let pageItem;
    let parameters;
    let promise1 = new Promise((resolve, reject) => {
      if (typeof websitePageItemId !== "undefined") {
        axios
          .get(baseURLGetPage, {
            params: {
              id: websitePageItemId,
            },
          })
          .then((response) => {
            if (response.data) {
              pageItem = response.data;
              let queries = response.data["QueryString"] ? response.data["QueryString"] : "";

              let queryColorsArr = queries.split("colors=");
              queryColorsArr = queryColorsArr[1] ? queryColorsArr[1].split("&") : [];
              let queryColors = queryColorsArr[0] ? queryColorsArr[0] : "";
              let queryColorsSelected = queryColors.split(",").filter((n) => n)
                ? [...new Set(queryColors.split(","))].filter((n) => n)
                : [];

              let queryPatternsArr = queries.split("patterns=");
              queryPatternsArr = queryPatternsArr[1] ? queryPatternsArr[1].split("&") : [];
              let queryPatterns = queryPatternsArr[0] ? queryPatternsArr[0] : "";
              let queryPatternsSelected = queryPatterns.split(",").filter((n) => n)
                ? [...new Set(queryPatterns.split(","))].filter((n) => n)
                : [];

              let queryTypesArr = queries.split("types=");
              queryTypesArr = queryTypesArr[1] ? queryTypesArr[1].split("&") : [];
              let queryTypes = queryTypesArr[0] ? queryTypesArr[0] : "";
              let queryTypesSelected = queryTypes.split(",").filter((n) => n)
                ? [...new Set(queryTypes.split(","))].filter((n) => n)
                : [];

              let queryPricesArr = queries.split("prices=");
              queryPricesArr = queryPricesArr[1] ? queryPricesArr[1].split("&") : [];
              let queryPrices = queryPricesArr[0] ? queryPricesArr[0] : "";
              let queryPricesSelected = queryPrices.split(",").filter((n) => n)
                ? [...new Set(queryPrices.split(","))].filter((n) => n)
                : [];

              let queryDesignsArr = queries.split("designs=");
              queryDesignsArr = queryDesignsArr[1] ? queryDesignsArr[1].split("&") : [];
              let queryDesigns = queryDesignsArr[0] ? queryDesignsArr[0] : "";
              let queryDesignsSelected = queryDesigns.split(",").filter((n) => n)
                ? [...new Set(queryDesigns.split(","))].filter((n) => n)
                : [];

              queryObj = {
                colors: queryColorsSelected,
                patterns: queryPatternsSelected,
                types: queryTypesSelected,
                prices: queryPricesSelected,
                designs: queryDesignsSelected,
              };
              parameters = JSON.parse(response.data["Parameters"] || "{}");
              resolve();
            } else {
              reject();
            }
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      } else {
        resolve();
      }
    });

    promise1
      .then(() => {
        if (modelID && modelID !== "null") {
          if (specialID) {
            if (modelID === "0326" && specialID === "1") {
              setPageModel(
                <DK2
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0099") {
              if (specialID === "Drapery&Sheers") {
                setPageModel(
                  <Grommet
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              } else if (specialID === "DraperyOnly") {
                setPageModel(
                  <Grommet2
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              } else if (specialID === "SheersOnly") {
                setPageModel(
                  <Grommet3
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              }
            } else if ((modelID === "0097" || modelID === "0328") && specialID === "1") {
              setPageModel(
                <Roman2
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0321") {
              if (specialID === "Drapery&Sheers") {
                setPageModel(
                  <PleatedOne
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              } else if (specialID === "DraperyOnly") {
                setPageModel(
                  <PleatedTwo
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              } else if (specialID === "SheersOnly") {
                setPageModel(
                  <PleatedThree
                    CatID={catID}
                    ModelID={modelID}
                    PageType={specialID}
                    ProjectId={projectId}
                    EditIndex={editIndex}
                    PageItem={pageItem}
                    QueryString={queryObj}
                    Parameters={parameters}
                    PageId={websitePageItemId}
                  />
                );
              }
            }
          } else {
            if (modelID === "0303") {
              setPageModel(
                <Zebra
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0324") {
              setPageModel(
                <Roller
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0325") {
              setPageModel(
                <DualRoller
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0326") {
              setPageModel(
                <DK
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            } else if (modelID === "0097" || modelID === "0327" || modelID === "0328") {
              setPageModel(
                <Roman
                  CatID={catID}
                  ModelID={modelID}
                  PageType={specialID}
                  ProjectId={projectId}
                  EditIndex={editIndex}
                  PageItem={pageItem}
                  QueryString={queryObj}
                  Parameters={parameters}
                  PageId={websitePageItemId}
                />
              );
            }
          }
        } else {
          setPageModel(<p>No Page Item</p>);
          navigate("/" + pageLanguage);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageModel(<p>No Page Item</p>);
      });
  };

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (editIndex !== undefined) {
      if (isLoggedIn) {
        if (pageLanguage !== "") {
          setPage();
        }
      } else if (
        localStorage.getItem("cart") !== null &&
        JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined
      ) {
        if (pageLanguage !== "") {
          setPage();
        }
      } else {
        if (pageLanguage !== "") {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
          setPage();
        }
      }
    } else {
      if (pageLanguage !== "") {
        setPage();
      }
    }
  }, [pageLanguage, location.pathname]);

  return <div className="custom_page_Container">{pageModel}</div>;
}

export default CustomCurtain;
